import React from 'react';
import StartModal from './StartModal';

const HowToPlay = ({ onStart, onClose, difficulty, isTutorial }) => {
    const startLabel = isTutorial ? 'Start Practice Board' : 'Start';
    return (
        <StartModal title='How to play' difficulty={difficulty} startLabel={startLabel} onStart={onStart} onClose={onClose}>
            <p>Start with the first target number. Use the operator buttons to transform the current number to match each target in sequence.</p>
            <p>Reach each target in order. When all targets are reached the round ends.</p>

            <div style={{ marginTop: '0.25rem', textAlign: 'center' }}>
                <span style={{ fontSize: '1.8vh', lineHeight: 1 }}>
                    The timer starts when you press <strong>{startLabel}</strong>.
                </span>
            </div>
        </StartModal>
    );
};

export default HowToPlay;
